export const slideShowAcceptedExtensions: string[] = ['.key', '.ppt', '.pptx', '.pdf', '.docx'];
export const acceptedFileTypes: string[] = [
  'application/pdf',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.apple.keynote',
  'application/x-iwork-keynote-sffkey',
];
